<template>  
  <div class="container-recepcao"> 
    <h3> Recepção <span class="label label-warning">{{ this.unidadeNome(filial) }}</span> </h3>
    <ul class="nav nav-tabs" role="tablist">
      <li role="presentation" class="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab">Recepção</a></li>
      <li role="presentation"><a href="#relatorio" aria-controls="relatorio" role="tab" data-toggle="tab">Relatório</a></li> 
    </ul> 
    <div class="tab-content">
      <div role="tabpanel" class="tab-pane fade in active" id="home">
        <div class="col-lg-6">
          <Agendado :data="this.dia" :filial="this.filial" :acessoBotoes="this.permissaoBotoes" />
        </div>
        <div class="col-lg-6">
          <EmAtendimento :data="this.dia" :filial="this.filial" :acessoBotoes="this.permissaoBotoes" /> <br /> 
        </div> 
        <div class="col-lg-12"> 
          <Reagendar :data="this.dia" :filial="this.filial" :acessoBotoes="this.permissaoBotoes" />
        </div>  
      </div>
      <div role="tabpanel" class="tab-pane fade" id="relatorio">
        <div class="form-group text-left">




          <label for="DataAgenda" v-show="isHabilitado" class=" " style="margin-top: 7px;">Recepção do Dia: </label>   
          <label for="DataAgenda" v-show="!isHabilitado" class=" " style="margin-top: 7px;">Pesquisando... </label>   
            <div class="input-group">
              <div class="input-group-addon">
              <i class="fa fa-calendar" aria-hidden="true"></i>
              </div>
              <div class="input-group">
                <input type="date" class="form-control " id="DataAgenda" v-model="diaSelecionado" style="font-size: 19px;" /> 
                <span class="input-group-btn">
                  <button class="btn btn-primary" type="button" @click="pesquisar"> 
                    <i class="fa fa-search" v-show="isHabilitado"></i> 
                    <i class="fa fa-circle-o-notch fa-spin" v-show="!isHabilitado"></i>
                  </button>
                </span>
              </div><!-- /input-group --> 
            </div>    
        </div>  
        <div v-show="resultado.length != 0" class="text-right" style="margin-bottom:5px"> 
          <strong v-if="this.selecionados.length" style="float:left; margin-top:20px">{{this.selecionados.length}} ficha(s) selecionada(s)</strong> 
          <button type="button" class="btn btn-default" title="Exportar para o GI " @click="exportarGi">
            <i class="fa fa-upload" aria-hidden="true"></i> &nbsp;
            Exportar para o GI 
          </button>
          <!-- <button type="button" class="btn btn-default" title="Finalizar Ficha(s)" @click="finalizarFicha">
            <i class="fa fa-flag-checkered" aria-hidden="true"></i> &nbsp;
            Finalizar Ficha(s)
          </button> -->
          <!-- <button type="button" class="btn btn-default" title="Imprimir Ficha(s)" @click="OpenAll">
            <i class="fa fa-print" aria-hidden="true"></i> &nbsp;
            Abrir Ficha(s) para Impressão
          </button> -->
          <br />  <br />  
        <input type="text" placeholder="Pesquisar" v-model="filtro" class="form-control"> 
        </div> 
          <table v-show="resultado.length != 0" class="table table-striped">
            <thead>
              <tr>
                <td>Nome</td>
                <td>CPF</td>
                <td>Data Atend.</td>
                <td>Status </td>
                <td>Tipo Atend.</td>
                <td>Obs. Atend.</td>  
                <td>Vaga</td>
                <td>Ficha Aprov.</td> 
                <td><input type="checkbox" v-model="selectAll"/></td> 
              </tr> 
            </thead>
            <tbody>
              <tr v-for="row of filteredData" :key="row" style="width:100% !important">
                <td style="width:290px !important; text-align:left">
                  <div v-if="row.Candidato != null">
                    {{ row.Candidato.Nome }} 
                  </div>
                  <div v-else>
                    -
                  </div>
                </td>
                <td style="width:140px !important">
                  <div v-if="row.Candidato != null">
                    {{ row.Candidato.CPF }} 
                  </div>
                  <div v-else>
                    -
                  </div> 
                </td>
                <td style="width:140px !important">{{ formatarData(row.DataHorario) }}</td>
                <td style="width:110px !important">{{ statusAtendimento(row.Status) }}</td>
                <td style="width:110px !important">
                  <small v-if="row.Tipo == 0" class="label label-info"> Admissão </small>
                  <small v-if="row.Tipo == 1" class="label label-danger"> Rescisão </small>
                  <small v-if="row.Tipo == 2" class="label label-default"> Outros </small> 
                </td>
                <td style="width:110px !important; text-align:left" :title="row.Observacoes">{{ row.Observacoes.substring(0, 30) }}</td>  
                <td style="width:130px !important">
                  <div v-if="row.Vaga != null">
                    <a target="_blank" :href="'http://fastrhluandre.com.br/Vagas/Visualizar/' + row.Vaga.Id" :title="row.Vaga.Id"> {{ row.Vaga.Id }} </a> 
                  </div>
                  <div v-else>
                    -
                  </div>
                </td>
                <td style="width:110px !important">
                  <div v-if="row.FichaAprovacao != null"> 
                    <a target="_blank" :href="'http://fastrhluandre.com.br/FichaAprovacao/Visualizar/' + row.FichaAprovacao.Id" :title="row.FichaAprovacao.Id"> {{ row.FichaAprovacao.Id }} </a>
                  </div>  
                  <div v-else>
                    -
                  </div>
                </td> 
                <td>
                  <span v-if="row.FichaAprovacao != null">
                      <input type="checkbox" :value="row.FichaAprovacao.Id" v-model="selecionados" number />
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div> 
    <ModalNaoExportou :fichas="naoExportou" />
  </div>  
</template>
<script>
import Agendado from './Agendado.vue'
import ModalNaoExportou from './shared/modal/NaoExportou.vue'
import EmAtendimento from './EmAtendimento.vue'
import Reagendar from './Reagendar.vue'
import ListarAgendamentos from './shared/recepcao/ListarAgendamentos.vue'
import moment from 'moment'
export default {
  methods: {
    abreModalNaoExportou () {
      $('#modalNaoExportou').modal('show')
    },
    finalizarFicha () {
      for (var i = 0; i < this.selecionados.length; i++) {
        alert('finalizando ficha: ' + this.selecionados[i])
      }
    },
    PrintAll () {
      // for (var i = 0; i < this.selecionados.length; i++) {
      //   alert('imprimindo ficha: ' + this.selecionados[i])
      // }
      for (var i = 0; i < this.pages.length; i++) {
        this.oWindow[i].print()
        this.oWindow[i].close()
      }
    },
    OpenAll () {
      if (this.selecionados.length > 10) {
        alert('Para impressão, selecione no máximo 10 fichas.')
        return false
      }
      for (var i = 0; i < this.selecionados.length; i++) {
        this.oWindow[i] = window.open('http://fastrhluandre.com.br/FichaAprovacao/Visualizar/' + this.selecionados[i])
      }
      var self = this
      setTimeout(function () {
        self.PrintAll()
      }, 5000)
    },
    exportarGi () {
      this.naoExportou = []
      if (this.selecionados.length === 0) {
        alert('Você deve selecionar ao menos 1 ficha')
        return false
      }
      for (var i = 0; i < this.selecionados.length; i++) {
        this.$http.get('agendamento/exportar/ficha?idFicha=' + this.selecionados[i] + '&IdUsuario=' + JSON.parse(localStorage.getItem('Usuario')).Usuario.Id)
        .then(function (res) {
        })
        .catch(function (err) {
          this.naoExportou.push(err.body)
          this.abreModalNaoExportou()
        })
      }
    },
    pesquisar () {
      this.isHabilitado = false
      this.$http.get('agendamento/recepcao?data=' + this.diaSelecionado + '&unidade=' + this.filial)
      .then(function (res) {
        this.isHabilitado = true
        this.resultado = res.body
      })
      .catch(function (err) {
        this.isHabilitado = true
        console.error(err)
      })
    },
    formatarData: function (d) { return moment(String(d)).format('DD/MM/YYYY HH:mm') },
    statusAtendimento (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Agendado'
          break
        case 1:
          escrito = 'Em Atendimento'
          break
        case 2:
          escrito = 'Em Atendimento Coletivo'
          break
        case 3:
          escrito = 'Finalizado'
          break
        case 4:
          escrito = 'Exame Médico'
          break
        case 5:
          escrito = 'Reagendar'
          break
        case 6:
          escrito = 'Aguardando'
          break
        case 7:
          escrito = 'Removido'
          break
        case 8:
          escrito = 'Aguardando Retorno Candidato'
          break
      }
      return escrito
    },
    unidadeNome: function (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Matriz'
          break
        case 1:
          escrito = 'ABC'
          break
        case 2:
          escrito = 'Alphaville'
          break
        case 4:
          escrito = 'Campinas'
          break
        case 5:
          escrito = 'Curitiba'
          break
        case 6:
          escrito = 'Faria Lima'
          break
        case 7:
          escrito = 'Guarulhos'
          break
        case 8:
          escrito = 'Jundiaí'
          break
        case 10:
          escrito = 'Rio de Janeiro'
          break
        case 11:
          escrito = 'Santo Amaro'
          break
        case 14:
          escrito = 'Recife'
          break
      }
      return escrito
    }
  },
  components: {
    Agendado,
    EmAtendimento,
    Reagendar,
    ListarAgendamentos,
    ModalNaoExportou
  },
  computed: {
    selectAll: {
      get: function () {
        return this.resultado ? this.selecionados.length >= 1 : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.resultado.forEach(function (item) {
            if (item.FichaAprovacao != null) {
              selected.push(item.FichaAprovacao.Id)
            }
          })
        }
        this.selecionados = selected
      }
    },
    filteredData: function () {
      var filtro = this.filtro && this.filtro.toLowerCase()
      var data = this.resultado
      if (filtro) {
        data = data.filter(function (pessoa) {
          return pessoa.Candidato.Nome.toLowerCase().indexOf(filtro) > -1
        })
      }
      return data
    }
  },
  created () {
    this.dia = moment().format('YYYY-MM-DD')
    this.filial = parseInt(localStorage.getItem('Unidade'))
    this.permissaoBotoes = JSON.parse(localStorage.getItem('Usuario')).BotoesRecepcao === 'OK'
  },
  data () {
    return {
      dia: '',
      filial: '',
      permissaoBotoes: false,
      diaSelecionado: '',
      isHabilitado: true,
      resultado: [],
      selecionados: [],
      oWindow: [],
      naoExportou: [],
      filtro: ''
    }
  }
}
</script>
<style scoped> 
.container-recepcao{
  width:100%;
  padding:0;
  margin:0;
}
.header span{
  border: 1px solid black;
  padding: 0 20px;
}
@media print {
  body * {
    visibility: hidden;
  }
  .printable, .printable * {
    visibility: visible;
  }
  .printable {
    position: fixed;
    left: 0;
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Recepcao.vue?0d80250d